module.exports = __webpack_public_path__ + "img/cww_09.4d77ccf7.jpg";